/* NOMI v23.34: Our Nutrition "The noodle, annotated".
   - Ingredient picker: hero callouts, chips, bar segments and cards all select the same detail panel (ARIA tabs).
   - Arrows draw in, the disc tilts toward the pointer, cards/steps stagger in, "No ___" lines strike through.
   Content is complete without JS; motion is skipped under prefers-reduced-motion. */
(function () {
  var root = document.querySelector('[data-nn]');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- picker ---------- */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
  var detail = root.querySelector('[data-nn-detail]');
  function countUp(el) {
    var end = parseFloat(el.getAttribute('data-nn-count'));
    if (reduce || !window.requestAnimationFrame) { el.textContent = end.toFixed(1); return; }
    var t0 = null, dur = 700;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3);
      el.textContent = (end * k).toFixed(1);
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function select(key, opts) {
    opts = opts || {};
    var tab = root.querySelector('#nn-tab-' + key);
    var panel = root.querySelector('#nn-panel-' + key);
    if (!tab || !panel) return;
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = root.querySelector('#' + t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-nn-pick]'), function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-nn-pick') === key && b.getAttribute('role') !== 'tab');
    });
    panel.classList.remove('is-in'); void panel.offsetWidth; panel.classList.add('is-in');
    var c = panel.querySelector('[data-nn-count]'); if (c) countUp(c);
    if (opts.focus) tab.focus();
    if (opts.scroll) {
      var r = panel.getBoundingClientRect();
      if (r.top < 70 || r.top > window.innerHeight * 0.6) {
        window.scrollTo({ top: window.scrollY + r.top - 96, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
  }
  root.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-nn-pick]');
    if (!b || !root.contains(b)) return;
    select(b.getAttribute('data-nn-pick'), { scroll: true });
  });
  root.addEventListener('keydown', function (ev) {
    var t = ev.target;
    if (t.getAttribute('role') !== 'tab') return;
    var i = tabs.indexOf(t), n = tabs.length, j = -1;
    if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') j = (i + 1) % n;
    else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') j = (i - 1 + n) % n;
    else if (ev.key === 'Home') j = 0;
    else if (ev.key === 'End') j = n - 1;
    if (j < 0) return;
    ev.preventDefault();
    select(tabs[j].getAttribute('data-nn-pick'), { focus: true });
  });

  if (reduce) return;
  root.classList.add('nn-motion');

  /* ---------- reveals ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('.nn-grid .nn-card, .nn-steps .nn-step'), function (el, i, all) {
    var sibs = Array.prototype.indexOf.call(el.parentNode.children, el);
    el.style.setProperty('--d', sibs);
  });
  var targets = root.querySelectorAll('.nn-rv, [data-nn-stage], [data-nn-nos]');
  function show(el) {
    el.classList.add('is-in');
    if (el.hasAttribute('data-nn-nos')) setTimeout(function () { el.classList.add('is-struck'); setTimeout(function () { el.classList.remove('is-struck'); }, 1400); }, 500);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(targets, function (el) { io.observe(el); });
  } else {
    Array.prototype.forEach.call(targets, show);
  }

  /* ---------- disc tilts toward the pointer ---------- */
  var stage = root.querySelector('[data-nn-stage]');
  var disc = root.querySelector('.nn-disc');
  if (stage && disc && fine) {
    var raf = 0, px = 0, py = 0;
    stage.addEventListener('pointermove', function (ev) {
      var r = stage.getBoundingClientRect();
      px = (ev.clientX - r.left) / r.width - 0.5;
      py = (ev.clientY - r.top) / r.height - 0.5;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        disc.style.setProperty('--ry', (px * 18).toFixed(2) + 'deg');
        disc.style.setProperty('--rx', (-py * 14).toFixed(2) + 'deg');
      });
    });
    stage.addEventListener('pointerleave', function () {
      disc.style.setProperty('--ry', '0deg'); disc.style.setProperty('--rx', '0deg');
    });
  }
})();
